/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/postAuditLogEntriesOverrides';
import type { PostAuditLogEntriesQueryParams } from '../../operation-overrides/postAuditLogEntriesOverrides';

export type { PostAuditLogEntriesQueryParams };

export type PostAuditLogEntriesRequestBody = OperationRequestBodyContent<operations['postAuditLogEntries']>;

export interface Input {
  apiVersion?: string;
  query?: PostAuditLogEntriesQueryParams;
  body: PostAuditLogEntriesRequestBody;
}

export async function postAuditLogEntries(
  { apiVersion, body, query }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/auditlog', {
    params: {
      // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
      query,
    },
    // @ts-ignore We explicitly ignore errors here because we know the types may not match the spec
    querySerializer: overrides.querySerializer,
    body,
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
